// Banks Vuex

import state from './bankStates.js'
import * as getters from './bankGetters.js'
import * as mutations from './bankMutations.js'
import * as actions from './bankActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
